// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './SelectPlanComp.css';
import { Row, Col } from 'react-flexbox-grid';
import MdCheckCircle from 'react-icons/lib/md/check-circle';
import MdUncheckCircle from 'react-icons/lib/md/radio-button-unchecked';
import WizardActions from '../actions/wizard.actions';
import { bindActionCreators } from 'redux';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import Button from '../common/ButtonComp';
import Input from 'react-toolbox/lib/input';
import qs from 'query-string';
import MdHelpOutline from 'react-icons/lib/md/help-outline';
import Tooltip from 'react-toolbox/lib/tooltip';
import Link from 'react-toolbox/lib/link';
import Dialog from 'react-toolbox/lib/dialog/Dialog';
import StripeCheckout from 'react-stripe-checkout';

import { KwhStripeLogoImg, plansData } from '../brand-configs';

import { routerActions } from 'react-router-redux';
import { getTranslate } from 'react-localize-redux';
const TooltipLink = Tooltip(Link);
const dataLayer = window.dataLayer;

const PLANS_FEATURES = {
  free: [
    '_page_path',
    '_status_code',
    'user_agent',
    'session',
    'user',
    '_e',
    '_e',
    '_e',
    '_e',
    'e',
    'e',
    'e',
    'e',
    'e',
    'e'
  ],
  big: [
    '_page_path',
    '_status_code',
    'user_agent',
    'session',
    'user',
    '_bot_name',
    'device',
    'location',
    '_e',
    '_e',
    '_e',
    'e',
    'e',
    'e',
    'e'
  ],
  giant: [
    '_page_path',
    '_status_code',
    'user_agent',
    'session',
    'user',
    '_bot_name',
    'device',
    'location',
    '_refferal',
    'ip',
    'is_bot',
    'response_time',
    'request_method',
    '_e',
    '_e'
  ],
  ultimate: [
    '_page_path',
    '_status_code',
    'user_agent',
    'session',
    'user',
    '_bot_name',
    'device',
    'location',
    '_refferal',
    'ip',
    'is_bot',
    'response_time',
    'request_method',
    '_attack_detection',
    '_spam_detection'
  ]
};

class SelectPlanComp extends Component {
  state = {
    selectedPlan: null,
    coupon: '',
    seeAllFeatures: false,
    showPaymentFailedDialog: false
  };
  constructor(props) {
    super(props);
    const {
      query: { idx = 0, failed },
      project
    } = this.props;

    this.state = {
      selectedPlan: project.plan,
      coupon: '',
      seeAllFeatures: false,
      showPaymentFailedDialog: failed === 'true'
    };
  }
  componentDidMount() {
    loadScript('https://js.stripe.com/v3/');
    this.props.wizardActions.getPlansByCoupon({ coupon: '' });
  }
  couponChange(coupon) {
    this.setState({ coupon, selectedPlan: null });
    this.props.plansActions.getPlansByCoupon({ coupon });
  }
  goBack() {
    const { idx = 0 } = this.props.query;
    this.props.routerActions.push(`select-web-property?idx=${idx}`);
  }
  goNext() {
    const {
      query: { idx = 0 },
      projects = []
    } = this.props;
    this.props.routerActions.push(`get-client?idx=${idx}`);
    if (projects && projects.length === 1 && projects[0].wizard[2])
      dataLayer.push({ firstPlanChoosed: true });
  }

  savePlan() {
    const {
      translate,
      project: { _id },
      query: { idx = 0 },
      routerActions,
      env: { STRIPE_PUBLISHABLE_KEY }
    } = this.props;
    const { user } = this.props.me;
    const { coupon, selectedPlan } = this.state;

    this.props.wizardActions.stripeCheckout({
      plan: selectedPlan,
      user,
      id: _id,
      coupon,
      stripe_key: STRIPE_PUBLISHABLE_KEY,
      currency: translate(`wizard.select_plan.currency`),
      cb: () => routerActions.push(`/wizard/get-client?idx=${idx}`)
    });
  }

  onToken(selectedPlan, token = null) {
    const {
      translate,
      project: { _id },
      query: { idx = 0 },
      routerActions,
      env: { STRIPE_PUBLISHABLE_KEY }
    } = this.props;
    const { user } = this.props.me;
    const { coupon } = this.state;

    this.props.wizardActions.stripeCheckout({
      token,
      plan: selectedPlan,
      user,
      id: _id,
      coupon,
      stripe_key: STRIPE_PUBLISHABLE_KEY,
      currency: translate(`wizard.select_plan.currency`),
      cb: () => routerActions.push(`/wizard/get-client?idx=${idx}`)
    });
  }

  switchPlan(plan, e) {
    if (e.target && e.target.getAttribute('class') === 'see-full-list') {
      return this.setState({ seeAllFeatures: true });
    }
    this.setState({ selectedPlan: plan });
  }
  closePaymentFailedDialog() {
    this.setState({ showPaymentFailedDialog: false });
  }

  render() {
    const {
      me: { user },
      query,
      goals,
      translate,
      wizard: { plans, wizardSaving },
      project,
      env: { STRIPE_PUBLISHABLE_KEY }
    } = this.props;
    const { selectedPlan } = this.state;

    const stripeCheckoutForPlan = (selectedPlan, buttonName) => {
      return (
        <Button
          big
          primary
          disabled={selectedPlan === null}
          loading={wizardSaving}
          onClick={this.onToken.bind(this, selectedPlan)}
        >
          {buttonName}
        </Button>
      );
    };

    const planId = project.plan && project.plan.id;
    const planChanged = selectedPlan && planId !== selectedPlan.id;

    const back = (
      <Button big secondary onClick={this.goBack.bind(this)}>
        {translate('app.back')}
      </Button>
    );
    let actionButton = (
      <Button big primary loading={wizardSaving} onClick={this.savePlan.bind(this)}>
        {translate('app.save')}
      </Button>
    );
    if (!planChanged) {
      actionButton = (
        <Button big primary loading={wizardSaving} onClick={this.goNext.bind(this)}>
          {translate('app.next')}
        </Button>
      );
    }

    if (!user.stripeSubscriptionId && selectedPlan && selectedPlan.price) {
      actionButton = stripeCheckoutForPlan(selectedPlan, translate('app.choose'));
    }

    if (!user.stripeSubscriptionId && selectedPlan && selectedPlan.price === 0) {
      actionButton = (
        <Button big primary loading={wizardSaving} onClick={this.savePlan.bind(this)}>
          {translate('app.next')}
        </Button>
      );
    }

    let paymentFailedDialog = this.state.showPaymentFailedDialog && (
      <Dialog
        actions={[
          {
            label: 'OK',
            onClick: this.closePaymentFailedDialog.bind(this)
          }
        ]}
        active={this.state.showPaymentFailedDialog}
        onEscKeyDown={this.closePaymentFailedDialog.bind(this)}
        onOverlayClick={this.closePaymentFailedDialog.bind(this)}
        title="Payment Failed"
      >
        <h4>Unfortunately the payment has failed</h4>
        <p>
          Please contact support <a href="mailto:support@log-hero.com">support@log-hero.com</a>
        </p>
      </Dialog>
    );

    return (
      <div className="wizard-select-plan">
        <h1>{translate('wizard.select_plan.select_plan_title')}</h1>
        <p className="space-big-bottom">{translate('wizard.select_plan.select_plan_details')}</p>
        <Row start="xs" className="space-big-bottom">
          <Col xs={3}>{plans.filter((p) => p.web_id === 'free').map(planTag.bind(this))}</Col>
          <Col xs={3}>{plans.filter((p) => p.web_id === 'big').map(planTag.bind(this))}</Col>
          <Col xs={3}>{plans.filter((p) => p.web_id === 'giant').map(planTag.bind(this))}</Col>
          <Col xs={3}>{plans.filter((p) => p.web_id === 'ultimate').map(planTag.bind(this))}</Col>
        </Row>
        <div className="kwh-button-group">
          {back}
          {actionButton}
        </div>
        {paymentFailedDialog}
      </div>
    );
  }
}

function planTag(plan) {
  const { translate, project } = this.props;
  const { selectedPlan, seeAllFeatures } = this.state;
  if (project.plan && plan.web_id === project.plan.web_id) {
    plan.price = project.plan.price;
  }
  const isActive = selectedPlan && plan.web_id === selectedPlan.web_id;
  const planClassName = [
    'wizard-plan',
    `wizard-plan-${plan.web_id}`,
    isActive ? 'wizard-plan-active' : '',
    seeAllFeatures ? `wizard-all-features` : ''
  ].join(' ');

  const priceNumber = !this.props.plansUpdating && Math.round(plan.price / 10) / 10;
  const price = this.props.plansUpdating ? (
    <ProgressBar type="circular" mode="indeterminate" />
  ) : (
    priceNumber
  );

  const checkIcon = isActive ? (
    <MdCheckCircle className="check-icon" />
  ) : (
    <MdUncheckCircle className="check-icon" />
  );

  const allFeatures = PLANS_FEATURES[plan.web_id];
  const seeFullList = !seeAllFeatures && (
    <div>
      <a className="see-full-list">see full list</a>
    </div>
  );
  return (
    <div className={planClassName} key={0} onClick={this.switchPlan.bind(this, plan)}>
      <h5>{translate(`plans.${plan.web_id}_plan`)}</h5>
      <div className="wizard-price-month">{price}</div>
      {allFeatures.map(renderFeatures.bind(this, allFeatures))}
      {seeFullList}
      {checkIcon}
    </div>
  );
}

function renderFeatures(vipFeatures, x, i) {
  const { translate } = this.props;
  const isVip = x.startsWith('_');
  const isVipClass = isVip ? 'vip-feature' : 'minor-feature';
  const tooltipClassName = !['e', '_e'].includes(x) ? `tooltip-feature` : ``;

  const elemContent = (
    <div key={i} className={`${isVipClass} ${tooltipClassName} feature`}>
      {translate(`plans.feat_${x}.title`)}
    </div>
  );

  const description = translate(`plans.feat_${x}.description`);

  if (!description.trim()) {
    return elemContent;
  }

  const PlanElemTooltip = Tooltip('div');

  return (
    <PlanElemTooltip key={i} tooltipDelay={300} tooltip={description} tooltipPosition="top">
      {elemContent}
    </PlanElemTooltip>
  );
}

//if (x === '_e' && vipFeatures[i-1] !== 'e') return ([<div><a href="#" onClick={(e)=>this.setState({seeAllFeatures: true}) && false}>see full list</a></div>, <div>{translate(`plans.feat_${x}`)}</div>])
function mapStateToProps(state) {
  const {
    routing: {
      location: { search }
    },
    project: {
      accounts,
      webProperties,
      accountsUpdating,
      webPropertiesUpdating,
      webPropertiesCreating
    }
  } = state;
  const query = search ? qs.parse(search) : { idx: 0 };

  const { projects } = state.me.user;

  if (query.id) {
    const { index = 0 } = projects.find(({ _id }) => _id === query.id) || {};
    query.idx = index;
  }

  return {
    query,
    translate: getTranslate(state.locale),
    wizard: state.wizard,
    me: state.me,
    project: state.me.user && state.me.user.projects[query.idx],
    env: state.env
  };
}

function loadScript(url, type, charset) {
  if (type === undefined) type = 'text/javascript';
  if (url) {
    var script = document.querySelector("script[src*='" + url + "']");
    if (!script) {
      var heads = document.getElementsByTagName('head');
      if (heads && heads.length) {
        var head = heads[0];
        if (head) {
          script = document.createElement('script');
          script.setAttribute('src', url);
          script.setAttribute('type', type);
          if (charset) script.setAttribute('charset', charset);
          head.appendChild(script);
        }
      }
    }
    return script;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    wizardActions: bindActionCreators(WizardActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch)
  };
}

function getCookie(n) {
  let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
  return a ? a[1] : '';
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectPlanComp);



// WEBPACK FOOTER //
// ./src/wizard/SelectPlanComp.js